import { QueryClient } from "@tanstack/react-query";

/*
 * Um cliente por aplicação, criado FORA do componente.
 *
 * Criá-lo dentro do corpo de `App` faria cada renderização produzir um cache
 * novo, e o polling da visão geral recomeçaria do zero a cada mudança de estado
 * — com uma requisição extra a cada volta.
 *
 * Mora aqui, e não em `App.tsx`, para `teste/preparo.ts` limpá-lo entre testes
 * sem carregar a aplicação inteira em todo arquivo de teste.
 */
export const cacheDaAplicacao = new QueryClient({
  defaultOptions: {
    queries: {
      /*
       * Sem retentativa por padrão. As respostas de erro do painel são
       * acionáveis — `401` é sessão, `403` é papel, `503` é fonte fora — e
       * repetir três vezes antes de mostrar a mensagem certa só atrasa quem
       * está diagnosticando um incidente.
       */
      retry: false,
      /*
       * Os dados do painel são operacionais e mudam sozinhos. Zero de
       * `staleTime` com intervalo explícito por tela (doc 06 §3) deixa a
       * decisão de frequência num lugar só: `api/consultas.ts`.
       */
      staleTime: 0,
    },
  },
});
